/**
 * Feature flag: tabs estilo Chrome (componentes permanecem montados ao trocar de aba).
 * Habilitado por padrão; desative com REACT_APP_TAB_KEEP_ALIVE=false no .env
 */
export const isTabKeepAliveEnabled = (): boolean =>
  process.env.REACT_APP_TAB_KEEP_ALIVE !== 'false';

/** Máximo de abas abertas. Favoritas não entram na fila de fechamento automático. */
export const MAX_OPEN_TABS = 10;

/** Rotas que não devem ficar em cache (muito pesadas em memória/GPU). */
export const TAB_KEEP_ALIVE_EXCLUDED_PATHS = new Set([
  '/production/factory-view',
]);

export const shouldKeepAlivePath = (pathname: string): boolean => {
  if (!isTabKeepAliveEnabled()) return false;
  if (TAB_KEEP_ALIVE_EXCLUDED_PATHS.has(pathname)) return false;
  return true;
};

/** Header e menus do AppBar — acima da barra de tabs e sidebar keep-alive. */
export const getHeaderOverlayZIndex = (theme: { zIndex: { modal: number } }): number =>
  theme.zIndex.modal + 4;

/**
 * Dialogs portados no body (fora do pane) — acima da barra de tabs.
 * Modais dentro do pane usam z-index padrão (modal) para tabs/sidebar ficarem clicáveis.
 */
export const getKeepAliveDialogZIndex = (theme: { zIndex: { modal: number } }): number =>
  theme.zIndex.modal + 2;

/** Variáveis CSS definidas no Layout para posicionar overlays no espaço útil. */
export const LAYOUT_DRAWER_WIDTH_CSS_VAR = '--mestti-layout-drawer-width';
export const LAYOUT_CHROME_TOP_CSS_VAR = '--mestti-layout-chrome-top';
/** Largura ocupada pelo chat (Otto) acoplado à direita; 0 quando fechado/expandido. */
export const LAYOUT_OPS_DOCK_CSS_VAR = '--mestti-layout-ops-dock';

/** Altura do AppBar fixo do Layout (as abas ficam dentro dele). */
export const APP_HEADER_HEIGHT_PX = 52;

/** Faixa própria de abas abaixo do AppBar: não existe mais (abas no AppBar). */
export const TAB_BAR_HEIGHT_PX = 0;

/** maxHeight seguro para dialogs abaixo do header + tabs keep-alive. */
export const getKeepAliveDialogMaxHeight = (fullScreen = false): string => {
  if (fullScreen) return '100dvh';
  const reserved = APP_HEADER_HEIGHT_PX + TAB_BAR_HEIGHT_PX + 32;
  return `calc(100dvh - ${reserved}px)`;
};

/** Sidebar e tabs — acima do backdrop do modal (keep-alive). */
export const getSidebarZIndex = (theme: { zIndex: { modal: number } }): number | undefined =>
  isTabKeepAliveEnabled() ? theme.zIndex.modal + 3 : undefined;

/** Tabs clicáveis — acima do backdrop do modal. */
export const getTabBarTabsZIndex = (theme: { zIndex: { modal: number } }): number =>
  theme.zIndex.modal + 3;